<template>
  <div class="nav-wrapper position-relative end-0">
    <ul class="nav nav-pills nav-fill p-1" role="tablist">
      <li v-for="(option, index) in options" :key="index" class="nav-item">
        <a
          class="nav-link mb-0 px-0 py-2"
          :class="{ active: activeTab === option }"
          @click="setActiveTab(option)"
          href="#"
          role="tab"
          :aria-selected="activeTab === option"
          >{{ option }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";

export default {
  name: "nav-pill",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: String,
      default: ''
    }
  },
  emits: ['update:activeTab'],
  mounted() {
    setNavPills();
  },
  methods: {
    setActiveTab(option) {
      this.$emit('update:activeTab', option);
    }
  }
};
</script>
